import styled from 'styled-components';


/**
 ContainerDefaultBox is placed over TrailerOrStripeImageComponent using position absolute.
 We do this because TrailerOrStripeImageComponent has opacity 0.5
 and we can't put ContainerDefaultBox inside TrailerOrStripeImageComponent because will inherit that opacity
 */

//demo-and-play
export const ContainerDefaultBox = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
`;
